export enum AppPlatform {
    Windows = "Windows",
    Android = "Android",
    MacOS = "MacOS",
}
